import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
type Props = {
  label?: string;
  show?: boolean;
  size?: string;
} & React.ComponentPropsWithoutRef<'div'>;
export function Loading(t0) {
  const $ = _c(23);
  let className;
  let label;
  let rest;
  let show;
  let size;
  if ($[0] !== t0) {
    ({
      show,
      label,
      size,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = label;
    $[3] = rest;
    $[4] = show;
    $[5] = size;
  } else {
    className = $[1];
    label = $[2];
    rest = $[3];
    show = $[4];
    size = $[5];
  }
  const t1 = !show;
  const t2 = show ? "block" : "hidden";
  let t3;
  if ($[6] !== className || $[7] !== t2) {
    t3 = twMerge("z-10 text-center transition duration-300", className, t2);
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = size || "size-20";
  let t5;
  if ($[9] !== t4) {
    t5 = twMerge("mx-auto animate-spin text-zinc-800 dark:text-zinc-300", t4);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />;
    t7 = <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5) {
    t8 = <svg className={t5} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">{t6}{t7}</svg>;
    $[13] = t5;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== label) {
    t9 = label ? <p className="m-0 mt-4 text-base font-medium text-zinc-800 dark:text-zinc-300">{label}</p> : <span className="sr-only">Loading</span>;
    $[15] = label;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== rest || $[18] !== t1 || $[19] !== t3 || $[20] !== t8 || $[21] !== t9) {
    t10 = <div aria-hidden={t1} className={t3} {...rest}>{t8}{t9}</div>;
    $[17] = rest;
    $[18] = t1;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
type PageLoadingProps = {
  className?: string;
  show: boolean;
} & React.ComponentPropsWithoutRef<'div'>;
export function PageLoading(t0) {
  const $ = _c(13);
  let className;
  let rest;
  let show;
  if ($[0] !== t0) {
    ({
      className,
      show,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = show;
  } else {
    className = $[1];
    rest = $[2];
    show = $[3];
  }
  const t1 = !show;
  const t2 = !show && "hidden";
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = twMerge("absolute top-12 right-0 left-0 z-10 mx-auto w-fit", className, t2);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="sr-only">Loading page</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="m-auto rounded-full bg-white p-2 shadow-lg dark:bg-zinc-200">{t4}<svg className="size-10 animate-spin text-red-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" /></svg></div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== rest || $[10] !== t1 || $[11] !== t3) {
    t6 = <div aria-hidden={t1} className={t3} {...rest}>{t5}</div>;
    $[9] = rest;
    $[10] = t1;
    $[11] = t3;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}